import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { selectIsMarketController, selectTSUserId } from '../../redux/globalsSlice';
// import TablesTemplate from './table_template';
import {
   ADD_ROW, ConvertStatus, DELETE_ROW,
   GetInstrumentTypeName, 
   JSON_KEY_CODE, 
   JSON_KEY_INSTRUMENT_TYPE, 
   JSON_KEY_DESCRIPTION, 
   TABLE_HEADER_CODE, 
   TABLE_HEADER_DESCRIPTION, 
   JSON_KEY_PRICE_DECIMALS, 
   TABLE_HEADER_PRICE_DECIMALS, 
   TABLE_HEADER_TYPE, 
   UPDATE_ROW, FormatWithDecimals, 
   INSTRUMENT_TYPE_CURRENCY,
   INSTRUMENT_TYPE_CRYPTO_CURRENCY,
   JSON_KEY_STATUS,
   priceChangeColor,
   instrumentCodeColor,
   rowOpacityForStatus,
   statusTextColor} from '../../common/common';
import VirtualizedTablesTemplate from './VirtualizedTablesTemplate';


const FormatInstrumentRow = (data) => {
   const id = data.code;
   const price_dec = Number(data.price_dec) || 0;
   const reference_price = data.ref;
   const previous_price = data.prev;
   const open_price = data.open;
   const close_price = data.close;
   const issue_qty = data.issue;

   return {
      ...data,
      id,
      issue: issue_qty != null ? FormatWithDecimals(issue_qty, 0) : "",
      ref: reference_price != null ? FormatWithDecimals(reference_price, price_dec) : "",
      prev: previous_price != null ? FormatWithDecimals(previous_price, price_dec) : "",
      open: open_price != null ? FormatWithDecimals(open_price, price_dec) : "",
      close: close_price != null ? FormatWithDecimals(close_price, price_dec) : "",
      i_type: GetInstrumentTypeName(data.i_type),
      status: ConvertStatus(data.status),
   };
};

const Currencies = () => {
   const [selectedRowId, setSelectedRowId] = useState(null);
   const tsUserId = useSelector(selectTSUserId);
   const tsUserIdRef = useRef(tsUserId);
   const isMarketController = useSelector(selectIsMarketController);
   const isMarketControllerRef = useRef(isMarketController);

   useEffect(() => {
      tsUserIdRef.current = tsUserId;
   }, [tsUserId]);

   useEffect(() => {
      isMarketControllerRef.current = isMarketController;
   }, [isMarketController]);

   const handleSingleClick = useCallback((rowData) => {
      // console.log(`[InstrumentsTable] Row Clicked:`, rowData, ", rowData.code:", rowData.code);
      // dispatch event for orderbook update
   }, []);

   const handleDoubleClick = useCallback((rowData) => {
      // console.log(`[InstrumentsTable] Row Double Clicked:`, rowData);
      // if (isMarketControllerRef.current) {
      //    setSelectedRow(rowData);
      //    setShowForm(true);          
      // }
   }, []);


   const columnStyling = useMemo(() => {
      const base = Object.fromEntries(
         ['last', 'open', 'high', 'low', 'vwap', 'close'].map((field) => [
            field,
            (rowData) => ({
               color: priceChangeColor(rowData[field], rowData.prev),
            }),
         ])
      );
      base[JSON_KEY_CODE] = (rowData) => ({
         color: instrumentCodeColor(rowData.status),
      });
      base[JSON_KEY_STATUS] = (rowData) => ({
         color: statusTextColor(rowData.status),
      });
      return base;
   }, []);
   
   // Handlers for instruments table
   const handleEvents = useCallback((details, setLocalTableData) => {
      // console.log('currencies handler, data: ', details.data);

      if ((details.data.i_type === INSTRUMENT_TYPE_CURRENCY) || (details.data.i_type === INSTRUMENT_TYPE_CRYPTO_CURRENCY)) {

         switch (details.type) {
            case ADD_ROW: {
               const modifiedRow = FormatInstrumentRow(details.data);
               setLocalTableData(prev => {
                  const exists = prev.some(row => row.id === modifiedRow.id);
                  if (exists) {
                     console.log(`Duplicate instrument with id ${modifiedRow.id} ignored.`);
                     return prev;
                  }
                  return [...prev, modifiedRow];
               });

               break;
            }
      
            case UPDATE_ROW: {
               const modifiedRow = FormatInstrumentRow(details.data);
               setLocalTableData(prev => prev.map(row => row.id === modifiedRow.id ? modifiedRow : row));
               break;
            }
      
            case DELETE_ROW: {
               const modifiedRow = FormatInstrumentRow(details.data);
               setLocalTableData(prev =>
                  prev.filter(row => row.code !== modifiedRow.code)
               );
               break;
            }

            default:
               break;
         }
      }
   }, []);


   const columns = useMemo(() => [
      // { Header: TABLE_HEADER_ID, accessor: JSON_KEY_ID }, // dont show it but it is still there
      { Header: TABLE_HEADER_CODE, accessor: JSON_KEY_CODE },
      { Header: TABLE_HEADER_DESCRIPTION, accessor: JSON_KEY_DESCRIPTION },
      { Header: TABLE_HEADER_TYPE, accessor: JSON_KEY_INSTRUMENT_TYPE },
      { Header: TABLE_HEADER_PRICE_DECIMALS, accessor: JSON_KEY_PRICE_DECIMALS },
   ], []);

   return (
      <>
         <VirtualizedTablesTemplate
            columns={columns}
            eventHandlers={handleEvents}
            tableName="CurrenciesTable"
            onRowClick={handleSingleClick}
            onRowDoubleClick={handleDoubleClick}
            highlightOnClick={true}
            selectedRowId={selectedRowId}
            setSelectedRowId={setSelectedRowId}
            enableSearch={true}
            columnStyling={columnStyling}
            rowStyling={(row) => ({ opacity: rowOpacityForStatus(row.status) })}
         />
      </>
   );
};

export default Currencies;
